module.exports = __webpack_public_path__ + "static/media/AMEX.b7ce9c70.svg";